export const formatTimestamp = (ts, options = {}) => {
    if (!ts) return 'N/A';
    const date = ts.$date ? new Date(ts.$date) : new Date(ts);
    return date.toLocaleString('en-US', options);
};

export const formatDuration = (ms) => {
    if (ms === undefined || ms === null || ms === 0) return '0s';
    
    if (ms < 1000) return `${ms}ms`;
    
    const totalSeconds = ms / 1000;
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (seconds > 0 || parts.length === 0) {
        // If we have hours or minutes, show seconds without decimals for cleaner look
        // unless it's only seconds
        const s = parts.length > 0 ? Math.floor(seconds) : seconds.toFixed(2);
        if (s > 0 || parts.length === 0) parts.push(`${s}s`);
    }
    
    return parts.join(' ');
};

export const formatDate = (date = new Date()) => {
    return date.toISOString().split('T')[0];
};

export const compareDates = (a, b) => {
    const dateA = a?.$date ? new Date(a.$date) : new Date(a);
    const dateB = b?.$date ? new Date(b.$date) : new Date(b);
    return dateB - dateA;
};

export const formatTime = (date = new Date()) => {
    return date.toLocaleTimeString();
};

export const getYear = (date = new Date()) => {
    return date.getFullYear();
};
